import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import RamenDiningIcon from "@mui/icons-material/RamenDining";
import {
    getCategoryKeyValue,
    addItem,
    updateItem,
    getItemDetail,
    getUnitKeyValueListByBaseUnit,
    getHsnKeyValuePair,
    getTaxExemptionKeyValuePair,
    getWarehouseKeyValueList,
    getInterStateTaxKeyValueList,
    getIntraStateTaxKeyValueList,
    getAccountKeyValueListByEnumString,
    getWarehouseKeyValueDetailsList,
    getItemList,
} from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Spinner } from "react-bootstrap";
import { SUB_CATEGORY_URL } from "../../../CONSTANTS";
import { callGetAxios } from "../../../services/common/common";
import InfoIcon from "@mui/icons-material/Info";


const ItemNew = (props) => {
    let navigate = useNavigate();
    let { id } = useParams();
    const [taxExOptions, setTaxExOptions] = useState([]);
    const [intraOptions, setIntraOptions] = useState([]);
    const [interOptions, setInterOptions] = useState([]);
    const [hsnOptions, setHsnOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [weightOptions, setWeightOptions] = useState([]);
    const [measureOptions, setMeasureOptions] = useState([]);
    const [otherOptions, setOtherOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [schemeItemsOptions, setSchemeItemsOptions] = useState([])
    const tempRow = {
        ware: "",
        reorderPoint: 0,
        openingStockValue: 0,
        currentStockBoxQuantity: 0,
        openingStockBoxQuantity: 0,
        openingStockOpenQuantity: 0,
    };
    const [rows, setRows] = useState([tempRow]);
    const [wareOptions, setWareOptions] = useState("");
    const [wareOptions2, setWareOptions2] = useState("");

    const [itemInfo, setItemInfo] = useState({
        type: "Goods",
        isProductionItem: false,
        isReturnable: false,
        isIngredient: false,
        isFloating: false,
        name: "",
        packUnit: "",
        itemWeight: 0,
        itemWeightUnit: "",
        boxWeight: "",
        length: 1,
        breadth: 1,
        height: 1,
        dimensionUnit: "",
        category: "",
        subCategory: "",
        sku: 0,
        itemCode: "",
        hsn: "",
        taxPref: "Taxable",
        taxExempt: "",
        intraTax: "",
        interTax: "",
        sellingPrice: 0,
        purchasePrice: 0,
        description: "",
        recipePriceValue: 0,
        isRecipePriceDynamic: true,
        schemeItemId: "",
        isSchemeItem: "",
        schemeItemTitle:""
    });

    useEffect(() => {
        if (id) {
            getItemDetail(id).then((res) => {
                if (res.errorCode === 0) {
                    const d = res.responsePacket;

                    let abc = d.warehouseItemsBeanList.map((a) => {
                        return {
                            ware: {
                                value: a.warehouseId,
                                label: a.warehouseTitle,
                            },
                            currentStockBoxQuantity: a.currentStockBoxQuantity,
                            currentStockOpenQuantity: a.currentStockOpenQuantity,
                            openingStockBoxQuantity: a.openingStockBoxQuantity,
                            openingStockOpenQuantity: a.openingStockOpenQuantity,
                            openingStockValue: a.openingStockValue,
                            reorderPoint: a.reorderPoint,
                        };
                    });
                    setRows(abc);
                    setItemInfo({
                        type: d.itemTypeEnum,
                        recipePriceValue: d.recipePriceValue,
                        isReturnable: d.isReturnable,
                        isIngredient: d.isIngredient,
                        isProductionItem: d.isProductionItem,
                        isFloating: d.isFloating,
                        name: d.title,
                        isRecipePriceDynamic: d.isRecipePriceDynamic,
                        packUnit: { value: d.packUnitId, label: d.packUnitTitle },
                        itemWeight: d.itemWeightQuantity,
                        itemWeightUnit: {
                            value: d.itemUnitId ? d.itemUnitId : "",
                            label: d.itemUnitTitle ? d.itemUnitTitle : "",
                        },
                        boxWeight: d.weightValue ? d.weightValue : "",
                        length: d.dimensionLength ? d.dimensionLength : 1,
                        breadth: d.dimensionBreadth ? d.dimensionBreadth : 1,
                        height: d.dimensionHeight ? d.dimensionHeight : 1,
                        dimensionUnit: {
                            value: d.dimensionUnitId ? d.dimensionUnitId : "",
                            label: d.dimensionUnitTitle ? d.dimensionUnitTitle : "",
                        },
                        category: { value: d.categoryId, label: d.categoryTitle },
                        subCategory: { value: d.subCategoryId, label: d.subCategoryTitle },
                        sku: d?.sku ? d.sku : "",
                        itemCode: d?.itemCode ? d.itemCode : "",
                        hsn: { value: d.hsnId, label: d.hsnSac },
                        taxPref: d.isTaxable ? "Taxable" : "NonTaxable",
                        taxExempt: {
                            value: d.taxExemptId,
                            label: d.taxExemptTitle,
                        },
                        intraTax: { value: d.taxIdIntrastate, label: d.taxTitleIntrastate },
                        interTax: { value: d.taxIdInterstate, label: d.taxTitleInterstate },
                        sellingPrice: d.sellingPriceValue ? d.sellingPriceValue : 0,
                        purchasePrice: d.purchasePriceValue ? d.purchasePriceValue : 0,
                        description: d.description || "",
                        isSchemeItem: d?.isSchemeItem,
                        schemeItemId: d?.schemeItemId,
                        schemeItemTitle:d?.schemeItemTitle
                    });
                }
            });
        }
    }, [id]);

    const handleReorder = (e, i) => {
        const obj = [...rows];
        let qt = Number(e.target.value);
        obj[i].reorderPoint = qt;
        // obj[i].openingStockValue = qt * obj[i].currentStockBoxQuantity;
        setRows(obj);
    };

    const handleOpenStock = (e, i) => {
        const obj = [...rows];
        let qt = Number(e.target.value);
        obj[i].currentStockBoxQuantity = qt;

        obj[i].openingStockValue = qt * obj[i].reorderPoint;
        setRows(obj);
    };
    const handleOpeningStockOpenQuantity = (e, i) => {
        const obj = [...rows];
        let qt = Number(e.target.value);
        obj[i].openingStockOpenQuantity = qt;

        // obj[i].openingStockValue = qt * obj[i].reorderPoint;
        setRows(obj);
    };

    const handleWare = (e, i) => {
        const obj = [...rows];
        obj[i].ware = e;
        setRows(obj);
        handleFilterItems(obj);
    };

    const handleFilterItems = (rows) => {
        var setSend = false;
        var filterOptions = [];
        wareOptions2 &&
            wareOptions2.map((a) => {
                rows &&
                    rows.map((b) => {
                        if (a.value === b?.ware?.value) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setWareOptions(filterOptions);
    };

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
        handleFilterItems(rows);
    };

    const handleClear = (i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
        handleFilterItems(obj);
    };

    useEffect(() => {
        getTaxExemptionKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setTaxExOptions(options);
            }
        });

        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));

                setWareOptions(options);
                setWareOptions2(options);
            }
        });

        getInterStateTaxKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setInterOptions(options);
            }
        });

        getIntraStateTaxKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setIntraOptions(options);
            }
        });

        getHsnKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setHsnOptions(options);
            }
        });

        getCategoryKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setCategoryOptions(options);
            }
        });

        const getSubCategoryKeyValue = async () => {
            try {
                const rUrl = SUB_CATEGORY_URL() + "getKeyValueList"
                const res = await callGetAxios(rUrl)
                if (res.errorCode === 0) {
                    const options = res.responsePacket.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setSubCategoryOptions(options);
                }

            } catch (error) {
                console.error(error)
            }
        }
        getSubCategoryKeyValue()

        getUnitKeyValueListByBaseUnit("Other").then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setOtherOptions(options);
            }
        });

        getUnitKeyValueListByBaseUnit("Weight").then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWeightOptions(options);
                getUnitKeyValueListByBaseUnit("Measure").then((res) => {
                    if (res.errorCode === 0) {
                        const options2 = res.responsePacket.map((d) => ({
                            value: d.key,
                            label: d.value,
                        }));
                        setMeasureOptions(options2);
                        if (id === undefined) {
                            setItemInfo({
                                ...itemInfo,
                                itemWeightUnit: options[0],
                                dimensionUnit: options2[0],
                            });
                        }
                    }
                });
            }
        });
    }, []);

    const handleData = (e, key) => {
        if (key === "check") {
            const { name, checked } = e.target;
            setItemInfo(prev => ({ ...prev, [name]: checked }));
        } else if (e.value && e.label) {
            setItemInfo(prev => ({ ...prev, [key]: e }));
        } else {
            const { name, value } = e.target;
            if (name === 'itemCode' && value && !/^[a-zA-Z0-9]+$/.test(value)) return;
            setItemInfo(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleDimension = (e) => {
        if (e.target.value > 0) {
            const { name, value } = e.target
            setItemInfo(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSave = (itemsList = null) => {
        if(itemInfo?.isSchemeItem&&(!itemInfo?.schemeItemId)&&(!itemInfo?.schemeItemTitle)){
            toast("please select  scheme item")
            return;
        }
        if (itemInfo.name === "") {
            toast("please select item name");
            return;
        }

        if (itemInfo.packUnit === "" || itemInfo.packUnit?.value === "") {
            toast("please select packUnit");
            return;
        }

        // if (itemInfo.boxWeight === "") {
        //   toast("please select boxWeight");
        //   return;
        // }

        // if (
        //   (itemInfo.dimensionUnit?.value!="") &&
        //   (itemInfo.height === 0 || itemInfo.length === 0 || itemInfo.breadth === 0)
        // ) {
        //   toast(" all dimensions should be > 0");
        //   return;
        // }

        if (itemInfo.category === "") {
            toast("Please select category");
            return;
        }
        if (!itemInfo.subCategory || itemInfo.subCategory === "") {
            toast("Please select subCategory");
            return;
        }

        // if (!itemInfo.itemCode || itemInfo.itemCode === "") {
        //     toast("Please select itemCode");
        //     return;
        // }

        if (itemInfo.hsn === "") {
            toast("Please select hsn");
            return;
        }

        if (!itemInfo.intraTax?.value || !itemInfo.interTax?.value) {
            toast("Tax field cant be empty");
            return;
        }
        setLoading(true);
        let rows2 = [];
        if (!itemsList) {
            // rows.map((a) => {
            //     a.warehouseId = a.ware.value;
            //     a.warehouseTitle = a.ware.label;
            // });
            // rows2 = rows.filter((a) => a.ware);
        } else {
            if (itemsList.ware) {
                itemsList.warehouseId = itemsList.ware.value;
                itemsList.warehouseTitle = itemsList.ware.label;
            }
            rows2.push(itemsList);
        }

        let data = {
            warehouseItemsBeanList: rows2.length === 0 ? [] : rows2,
            title: itemInfo.name,
            itemTypeEnum: itemInfo.type,
            isFloating: itemInfo.isFloating,
            isIngredient: itemInfo.isIngredient,
            isReturnable: itemInfo.isReturnable,
            isProductionItem: itemInfo.isProductionItem,
            recipePriceValue: itemInfo.recipePriceValue,
            isRecipePriceDynamic: itemInfo.isRecipePriceDynamic,
            // brandId: itemInfo.category.value,
            // brandTitle: itemInfo.category.label,
            categoryId: itemInfo.category.value,
            categoryTitle: itemInfo.category.label,
            subCategoryId: itemInfo.subCategory.value,
            subCategoryTitle: itemInfo.subCategory.label,

            description: itemInfo.description,
            dimensionLength: itemInfo.length,
            dimensionBreadth: itemInfo.breadth,
            dimensionHeight: itemInfo.height,
            dimensionUnitId: itemInfo.dimensionUnit?.value ? itemInfo.dimensionUnit.value : measureOptions[0].value,
            dimensionUnitTitle: itemInfo.dimensionUnit?.label ? itemInfo.dimensionUnit.label : measureOptions[0].label,

            hsnId: itemInfo.hsn.value,
            hsnSac: itemInfo.hsn.label?.toString(),
            sku: itemInfo?.sku ? itemInfo?.sku : 0,
            itemCode: itemInfo?.itemCode || "",

            isPurchase: itemInfo.purchasePrice > 0 ? true : false,
            purchaseCurrencyId: "dad7fa51-f498-42fb-a2d9-8efe52269ffc",
            purchaseAccountTypeEnum: "Expense",
            purchasePriceValue: itemInfo.purchasePrice,

            isSales: itemInfo.sellingPrice > 0 ? true : false,
            sellingCurrencyId: "dad7fa51-f498-42fb-a2d9-8efe52269ffc",
            sellingAccountTypeEnum: "Income",
            sellingPriceValue: itemInfo.sellingPrice,

            // taxExemptId:
            //   itemInfo.taxPref === "NonTaxable" ? itemInfo.taxExempt.value : "",
            // taxExemptTitle:
            //   itemInfo.taxPref === "NonTaxable" ? itemInfo.taxExempt.label : "",
            taxIdInterstate: itemInfo.interTax.value,
            taxIdIntrastate: itemInfo.intraTax.value,
            taxTitleInterstate: itemInfo.interTax.label,
            taxTitleIntrastate: itemInfo.intraTax.label,
            // isTaxable: itemInfo.taxPref === "Taxable" ? true : false,
            isTaxable: true,

            //box
            weightUnitId: itemInfo.packUnit.value,
            weightUnitTitle: itemInfo.packUnit.label,
            weightValue: itemInfo.packUnit.label === "Kgs" || itemInfo.packUnit.label === "Litres" ? 1 : itemInfo.boxWeight,
            //pack
            packUnitId: itemInfo.packUnit.value,
            packUnitTitle: itemInfo.packUnit.label,

            //item wt
            itemUnitId: itemInfo.itemWeightUnit?.value ? itemInfo.itemWeightUnit?.value : weightOptions[0].value,
            itemUnitTitle: itemInfo.itemWeightUnit.label ? itemInfo.itemWeightUnit.label : weightOptions[0].label,
            itemWeightQuantity: itemInfo.itemWeight,
            isSchemeItem: itemInfo?.isSchemeItem,
            schemeItemId: itemInfo?.schemeItemId,
            schemeItemTitle:itemInfo?.schemeItemTitle

        };

        if (id) {
            updateItem(id, data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast.success(res.message);
                        navigate("/items");
                        setLoading(false);
                    } else {
                        toast.error(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addItem(data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast.success(res.message);
                        navigate("/items");
                        setLoading(false);
                    } else {
                        toast.error(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };

    const handlePackUnit = (e) => {
        let kg1;
        let litre1;
        weightOptions.map((a) => {
            if (a.label === "Kg") {
                kg1 = a;
            }
            if (a.label === "Litre") {
                litre1 = a;
            }
        });

        if (e.label === "Kgs") {
            setItemInfo({ ...itemInfo, packUnit: e, itemWeightUnit: kg1 });
        } else {
            setItemInfo({ ...itemInfo, packUnit: e, itemWeightUnit: litre1 });
        }
    };


    const handleToggle = () => {
        const newValue = !itemInfo.isRecipePriceDynamic;
        setItemInfo({ ...itemInfo, isRecipePriceDynamic: newValue });
    };
    const handleShemeToggle = () => {
        const newValue = !itemInfo.isSchemeItem;
        if(newValue){
            setItemInfo({ ...itemInfo, isSchemeItem: newValue });
        }
        else{
            setItemInfo({ ...itemInfo, isSchemeItem: newValue,schemeItemId: "",schemeItemTitle:"" });
        }
    };
    const handleInputChange = (e) => {
        if (e.length < 2) {
            setSchemeItemsOptions([])
            return;
        }
        let list_data = {
            page: 0,
            size: -1,
            search: e,
            uuid: "",
            uuid2: ""
        };
        getItemList(list_data).then((res) => {
            if (res.errorCode === 0) {
                let options = res?.responsePacket?.data?.map((e) => { return { value: e?.recordId, label: e?.title } })
                setSchemeItemsOptions(options)
            }
            else {
                console.error("error in getting itemlist")
            }
        });
    }
    const handleSchemeItemChange = (e) => {
        setItemInfo({ ...itemInfo, schemeItemId: e?.value,schemeItemTitle:e?.label });
    }
    return (
        <>
            <div className="content-column" style={{ paddingBottom: "300px", paddingLeft: "15px" }}>
                <div className="fill list-header d-flex justify-content-between align-items-center bg-white p-3 border-bottom">
                    <h1>
                        <strong>
                            <RamenDiningIcon /> {id ? "Edit Item" : "New Item"}
                        </strong>
                    </h1>
                </div>
                <table>
                    <tr>
                        <td style={{ width: "150px" }}>Type:</td>
                        <td>
                            <RadioGroup row name="type" value={itemInfo.type} onChange={(e) => handleData(e)}>
                                <FormControlLabel value="Goods" control={<Radio size="small" />} label="Goods" />
                                <FormControlLabel value="Service" control={<Radio size="small" />} label="Service" />
                            </RadioGroup>
                        </td>
                        <td>
                            <Checkbox size="small" name="isReturnable" checked={itemInfo.isReturnable} onChange={(e) => handleData(e, "check")} />Returnable
                            <Checkbox size="small" name="isIngredient" checked={itemInfo.isIngredient} onChange={(e) => handleData(e, "check")} />Ingredient
                            <Checkbox size="small" name="isFloating" checked={itemInfo.isFloating} onChange={(e) => handleData(e, "check")} />Floating
                            <Checkbox size="small" name="isProductionItem" checked={itemInfo.isProductionItem} onChange={(e) => handleData(e, "check")} />Production
                        </td>
                    </tr>
                </table>

                <table className="requiredTable">
                    <tr>
                        <td style={{ width: "150px" }}>Name:</td>
                        <td style={{ width: "220px" }}>
                            <input autoComplete="off" onChange={(e) => handleData(e)} name="name" value={itemInfo.name} className="form-control" />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "150px" }}>Pack Unit:</td>
                        <td>
                            <Select
                                value={itemInfo.packUnit}
                                options={otherOptions}
                                onChange={(e) => {
                                    handlePackUnit(e);
                                }}
                            />
                        </td>
                    </tr>
                </table>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "600px",
                        margin: "5px",
                    }}
                >
                    <div style={{ width: "150px" }}>Pack contains</div>&nbsp;
                    {itemInfo.packUnit.label === "Kgs" || itemInfo.packUnit.label === "Litres" ? (
                        <></>
                    ) : (
                        <>
                            <Tooltip title="Box Weight">
                                <input
                                    autoComplete="off"
                                    style={{ width: "70px" }}
                                    type="number"
                                    onChange={(e) => handleData(e)}
                                    name="boxWeight"
                                    value={itemInfo.boxWeight}
                                    className="form-control"
                                />
                            </Tooltip>
                            &nbsp;&nbsp;
                            <span style={{ width: "65px" }}>{itemInfo.packUnit.label} of</span>
                        </>
                    )}
                    <Tooltip title="Item Weight">
                        <input
                            autoComplete="off"
                            style={{ width: "70px" }}
                            type="number"
                            onChange={(e) => handleData(e)}
                            name="itemWeight"
                            min={0}
                            value={itemInfo.itemWeight}
                            className="form-control"
                        />
                    </Tooltip>
                    &nbsp;&nbsp;
                    <Select
                        // id="s1"
                        value={itemInfo.itemWeightUnit}
                        options={weightOptions}
                        onChange={(e) => {
                            handleData(e, "itemWeightUnit");
                        }}
                    />
                    &nbsp;
                    <div style={{ width: "70px" }}>each</div>
                    &nbsp;&nbsp;
                </div>

                <table className="requiredTable">
                    <tr>
                        <td style={{ color: "black" }}>Total Pack Wt: </td>
                        <td>
                            {(Number(itemInfo.boxWeight) * Number(itemInfo.itemWeight))?.toFixed(2)}
                            &nbsp; {itemInfo.itemWeightUnit?.label}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "black", width: "150px" }}>Dimensions</td>
                        <td style={{ display: "flex" }}>
                            <input
                                autoComplete="off"
                                style={{ width: "70px" }}
                                type="number"
                                min={1}
                                onChange={(e) => handleDimension(e)}
                                name="length"
                                value={itemInfo.length}
                                className="form-control"
                            />

                            <input
                                autoComplete="off"
                                style={{ width: "70px" }}
                                type="number"
                                min={1}
                                onChange={(e) => handleDimension(e)}
                                name="breadth"
                                value={itemInfo.breadth}
                                className="form-control"
                            />

                            <input
                                autoComplete="off"
                                style={{ width: "70px" }}
                                type="number"
                                min={1}
                                onChange={(e) => handleDimension(e)}
                                name="height"
                                value={itemInfo.height}
                                className="form-control"
                            />
                        </td>
                        <td>
                            <Select
                                value={itemInfo.dimensionUnit}
                                options={measureOptions}
                                onChange={(e) => {
                                    handleData(e, "dimensionUnit");
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Category</td>
                        <td>
                            <Select
                                value={itemInfo.category}
                                options={categoryOptions}
                                onChange={(e) => {
                                    handleData(e, "category");
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Sub Category *</td>
                        <td>
                            <Select
                                value={itemInfo.subCategory}
                                options={subCategoryOptions}
                                onChange={(e) => {
                                    handleData(e, "subCategory");
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "black" }}>SKU:</td>
                        <td>
                            <input autoComplete="off" onChange={(e) => handleData(e)} name="sku" value={itemInfo.sku} className="form-control" />
                        </td>
                    </tr>
                    <tr style={{ color: "black" }}>
                        <td>ITEM CODE:</td>
                        <td>
                            <input autoComplete="off" onChange={(e) => handleData(e)} name="itemCode" value={itemInfo.itemCode} className="form-control" />
                        </td>
                    </tr>
                    <tr>
                        <td>HSN</td>
                        <td>
                            <Select
                                value={itemInfo.hsn}
                                options={hsnOptions}
                                onChange={(e) => {
                                    handleData(e, "hsn");
                                }}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>IntraState Tax</td>
                        <td>
                            <Select
                                value={itemInfo.intraTax}
                                options={intraOptions}
                                onChange={(e) => {
                                    handleData(e, "intraTax");
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>InterState Tax</td>
                        <td>
                            <Select
                                value={itemInfo.interTax}
                                options={interOptions}
                                onChange={(e) => {
                                    handleData(e, "interTax");
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>SellingPrice:</td>
                        <td>
                            <input autoComplete="off" className="form-control" type="number" min={0} name="sellingPrice" value={itemInfo.sellingPrice} onChange={(e) => handleData(e)} />
                        </td>
                    </tr>
                    <tr>
                        <td>PurchasePrice[In pack]:</td>
                        <td>
                            <input autoComplete="off" className="form-control" type="number" min={0} name="purchasePrice" value={itemInfo.purchasePrice} onChange={(e) => handleData(e)} />
                        </td>
                    </tr>
                    {id && <tr>
                        <td>Recipe Price Dynamic :</td>
                        <td>
                            <button
                                className={`toggle-btn ${itemInfo.isRecipePriceDynamic ? 'on' : 'off'}`}
                                onClick={() => handleToggle()}
                            >
                                {itemInfo.isRecipePriceDynamic ? 'On' : 'Off'}
                            </button>
                        </td>
                        <Tooltip
                            title={
                                itemInfo.isRecipePriceDynamic === true ? <h4>
                                    Recipe Price value updated by the latest GRN.
                                </h4> : <h4>
                                    Recipe Price value not updated by the latest GRN.
                                </h4>}
                        >
                            <InfoIcon />
                        </Tooltip>
                    </tr>}

                    {id && <tr>
                        <td> Recipe Price [In pack]:</td>
                        <td>
                            <input autoComplete="off" className="form-control" type="number" min={0} name="recipePriceValue" value={itemInfo.recipePriceValue} onChange={(e) => handleData(e)} />
                        </td>
                    </tr>}
                    <tr>
                        <td>Description:</td>
                        <td>
                            <input autoComplete="off" className="form-control" name="description" value={itemInfo.description} onChange={(e) => handleData(e)} />
                        </td>
                    </tr>
                    {id &&
                        <tr>
                            <td> Is Scheme Item:</td>
                            <td> <button
                                className={`toggle-btn ${itemInfo.isSchemeItem ? 'on' : 'off'}`}
                                onClick={() => handleShemeToggle()}
                            >
                                {itemInfo.isSchemeItem ? 'On' : 'Off'}
                            </button></td>
                        </tr>}
                    {(id && itemInfo?.isSchemeItem) &&
                        <tr>
                            <td>Items :</td>
                            <td> <Select
                                onChange={handleSchemeItemChange}
                                options={schemeItemsOptions}
                                onInputChange={handleInputChange}
                                filterOption={() => true}  // This disables filtering on typing
                                isClearable
                                value={{label:itemInfo?.schemeItemTitle,value:itemInfo?.schemeItemId}}
                            />
                            </td>
                        </tr>}
                </table>

                <br />
                <table className="customTable">
                    <tr>
                        <td style={{ width: "200px" }}>Warehouse</td>
                        <td>Reorder Level Set Point</td>
                        <td>
                            <tr>Opening Stock </tr>
                            <tr>Pack Qty</tr>
                        </td>
                        <td></td>
                        <td>
                            <tr>Opening Stock </tr>
                            <tr>Loose Qty</tr>
                        </td>
                        <td></td>
                        <td>
                            <tr>Opening Stock </tr>
                            <tr>Value</tr>
                        </td>
                        <td></td>
                    </tr>
                    {rows &&
                        rows.map((data, i) => {
                            return (
                                <>
                                    <tr>
                                        <td style={{ width: "200px" }}>
                                            <Select options={wareOptions} value={data.ware} onChange={(e) => handleWare(e, i)} />
                                        </td>
                                        <td>
                                            <input autoComplete="off" className="form-control" type="number" min={0} value={data.reorderPoint} onChange={(e) => handleReorder(e, i)} />
                                        </td>
                                        <td>
                                            <input autoComplete="off" className="form-control" type="number" min={0} value={data.currentStockBoxQuantity} onChange={(e) => handleOpenStock(e, i)} />
                                        </td>
                                        <td>{itemInfo.packUnit?.label}</td>
                                        <td>
                                            <input
                                                autoComplete="off"
                                                disabled={id ? true : false}
                                                className="form-control"
                                                type="number"
                                                min={0}
                                                value={data.openingStockOpenQuantity}
                                                onChange={(e) => handleOpeningStockOpenQuantity(e, i)}
                                            />
                                        </td>
                                        <td>{itemInfo.itemWeightUnit?.label}</td>
                                        <td>
                                            <input autoComplete="off" disabled="true" className="form-control" type="number" min={0} value={data.openingStockValue} />
                                        </td>
                                        <td style={{ cursor: "pointer" }} onClick={() => handleClear(i)}>
                                            {/* {rows.length > 1 && <i className="fa fa-times"></i>} */}
                                            <Button variant="contained" onClick={() => handleSave(data)}>
                                                Update
                                            </Button>
                                        </td>
                                    </tr>
                                </>
                            );
                        })}
                </table>

                <div>
                    <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
                        <AddIcon style={{ color: "blue" }} /> New Row
                    </button>
                </div>

                <br />
                <div>
                    {loading ? (
                        <Button variant="contained">
                            <Spinner />
                        </Button>
                    ) : (
                        <Button variant="contained" onClick={() => handleSave()}>
                            Save
                        </Button>
                    )}
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default ItemNew;
